module.exports = __webpack_public_path__ + "img/logo.d143b0ff.svg";